export const marketingInsightsNavItems = [
  {
    labelKey: 'marketingInsights.nav.marketingInsights',
    icon: 'rocket-launch',
    navKey: 'marketingInsightsGroup',
    visibility: {
      control: 'multiple' as const,
      // The union of the children's own gates, and nothing more. Reports 19/45 and the report 6/68
      // paid-social schedule tabs used to sit here for the Meta and TikTok explorer entries; with
      // those retired (ORP-18435) no child reads any of them, so a workspace entitled to only
      // Meta or TikTok would have seen this group open onto an empty list.
      id: [{ control: 'report' as const, id: [26, 60, 1, 5, 22, 43] }],
    },
    children: [
      {
        labelKey: 'marketingInsights.performanceMax.title',
        navKey: 'performanceMax',
        to: { name: 'PerformanceMaxCampaigns' },
        visibility: { control: 'report' as const, id: [26] },
      },
      {
        labelKey: 'marketingInsights.landingPage.title',
        navKey: 'landingPage',
        to: { name: 'LandingPage' },
        visibility: { control: 'report' as const, id: [22] },
      },
      {
        labelKey: 'marketingInsights.placementAnalysis.title',
        navKey: 'placementAnalysis',
        to: { name: 'PlacementAnalysis' },
        visibility: { control: 'report' as const, id: [60] },
        meta: {
          importance: 8,
          searchValue: 'Google Ads Placements Placement Analysis',
        },
      },
      {
        labelKey: 'marketingInsights.searchAdsExcellence.title',
        navKey: 'searchAdsExcellence',
        to: { name: 'SearchAdsExcellence' },
        visibility: { control: 'report' as const, id: [1, 5] },
      },
      {
        labelKey: 'marketingInsights.displayVideo360.title',
        navKey: 'displayVideo360',
        to: { name: 'DisplayVideo360' },
        visibility: { control: 'report' as const, id: [43] },
      },
      // HIDDEN, matching v3. `DefaultLayout.vue:399-427` carries this whole group commented out
      // in `standardNavigation`, so the live product has never shown Trends & Competition —
      // Marketing Insights lists four entries, not five. v4 had it live, which is a divergence
      // rather than a port. Commented rather than deleted for the same reason v3 did: the routes
      // (`CompetitorAnalysis`, `TrendSeasonalityAnalysis`) still exist and the group is expected
      // back, so this is a hidden entry, not a retirement.
      //
      // Report 47 and the `trend_analysis` permission left the parent gate with it: nothing else
      // reads either, and v3's own parent gate carries neither. Leaving them would open the group
      // onto an empty list for a workspace entitled to only those two.
      // {
      // labelKey: 'marketingInsights.nav.trendingCompetition',
      // navKey: 'trendingCompetitionGroup',
      // visibility: {
      // control: 'multiple' as const,
      // id: [
      // { control: 'report' as const, id: [47] },
      // { control: 'permission' as const, id: 'trend_analysis' },
      // ],
      // },
      // children: [
      // {
      // labelKey: 'marketingInsights.competitorAnalysis.title',
      // navKey: 'competitorAnalysis',
      // to: { name: 'CompetitorAnalysis' },
      // visibility: { control: 'report' as const, id: [47] },
      // },
      // {
      // labelKey: 'marketingInsights.nav.trendSeasonality',
      // navKey: 'trendSeasonality',
      // to: { name: 'TrendSeasonalityAnalysis' },
      // visibility: { control: 'permission' as const, id: 'trend_analysis' },
      // meta: {
      // importance: 7,
      // searchValue:
      // 'Trends Seasonality keyword volume seasonal trend random time series forecast competition',
      // },
      // },
      // ],
      // },
    ],
  },
]
